if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });

      // Add click handlers for variant swatches to link to media gallery
      this.addEventListener("click", (event) => {
        const swatch = event.target.closest('.variant-picker__option');
        if (swatch && swatch.dataset.mediaIndex !== undefined) {
          this.handleVariantSwatchClick(swatch);
        }
      });
    }

    handleVariantSwatchClick(swatch) {
      const mediaIndex = parseInt(swatch.dataset.mediaIndex);
      const productMedia = document.querySelector('.f-product__media');

      if (productMedia && !isNaN(mediaIndex)) {
        // Find the Flickity slider and select the corresponding slide
        const flickitySlider = productMedia.querySelector('.flickity-slider');
        if (flickitySlider) {
          const flickityInstance = window.FoxTheme.Flickity.data(flickitySlider);
          if (flickityInstance) {
            flickityInstance.select(mediaIndex, false, false);

            // Optional: Add a subtle highlight effect
            const selectedSlide = flickitySlider.children[mediaIndex];
            if (selectedSlide) {
              selectedSlide.style.transition = 'box-shadow 0.3s ease';
              selectedSlide.style.boxShadow = '0 0 0 3px rgba(0, 123, 255, 0.3)';

              setTimeout(function() {
                selectedSlide.style.boxShadow = '';
              }, 2000);
            }
          }
        }
      }
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
